import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import { userStatus, envConfig, store } from '../../../_helpers';
import { Loader } from '../../../_components';
import { history } from '../../../_helpers';
import moment from 'moment';

export default class OptinChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: this.props.parentDomain,
      labels: [],
      values: [],
      table_values: [],
      loaded: false,
      period: this.props.period === 1 ? 7 : this.props.period,
      start: this.props.period.start,
      end: this.props.period.end,
      cardSize: 0,

      chartOptions: {},
      chartSeries: []
    }

    this.card = React.createRef();

    this.handleResize = this.handleResize.bind(this);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.listAnalyticsData(this.state.domain, this.state.start, this.state.end);
  }

  async componentWillReceiveProps(nextProps) {
    if ( nextProps.period.start === this.state.start && nextProps.period.end === this.state.end ) return;
    // if ( nextProps.period < 7 ) return;

    await this.setState({
      loaded: false,
      period: nextProps.period,
      start: nextProps.period.start,
      end: nextProps.period.end,
      domain: this.state.domain,
      chartOptions: {},
      chartSeries: []
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period.start, nextProps.period.end));
  }

  handleResize = () => {
    if ( !this.card.current ) return;
    this.setState({cardSize: this.card.current.offsetWidth - 60});
  }

  async listAnalyticsData(domain, start, end) {
    const user = userStatus();
    const { endpoint } = this.state;

    if ( !domain ) domain = this.state.domain;
    if ( !start ) start = this.state.start;
    if ( !end ) end = this.state.end;

    const url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${user.bearer_token}` }
    }

    const request = await fetch(url, options);

    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }

    let response = await request.json();
    if ( response.data.length === 0 ) return;
    
    let dates = [];
    let optins = [];
    let optouts = [];

    await response.data.map((data) => {
      let date = moment(data.date).format('DD/MM/YY');
      
      dates.push(date);
      optins.push(data.optins);
      optouts.push(data.optouts);
    });

    let chartOptions = {
      chart: { id: "optins_optouts_chart" },
      xaxis: { categories: dates.reverse() }
    }
    let chartSeries = [
      {
        name: "Optins",
        data: optins.reverse()
      },
      {
        name: "Optouts",
        data: optouts.reverse()
      }
    ]

    if ( !this.card.current ) {
      return this.setState({chartOptions, chartSeries, loaded: true});
    }
    this.setState({chartOptions, chartSeries, loaded: true, cardSize: this.card.current.offsetWidth - 60});
  }

  render() {
    return (
      <div key={this.props.title} className={`col-xs-12 col-sm-12 col-md-${this.props.colsize} col-lg-${this.props.colsize}`}>
        <div className="card card-apex-fullWidth" ref={this.card}>
          <p className="title title-outside">{this.props.title}</p>
          
          {
            this.state.loaded ?
              this.state.chartOptions && this.state.chartSeries.length !== 0 ?
                <Chart
                  options={this.state.chartOptions}
                  series={this.state.chartSeries}
                  type="area"
                  width={this.state.cardSize}
                />
              : null
            : <Loader className="is-blue" />
          }
        </div>
      </div>
    )
  }
}